import React from "react";
import { Box } from "@mui/material";
import CardList from "./cardList";

const Rewards = () => {
  return (
    <Box
      flex={1}
      sx={{
        height: "90dvh",
        overflowY: "auto",
        position: "relative",
        borderRadius: 4,
      }}
    >
      <CardList />
    </Box>
  );
};

export default React.memo(Rewards);
